import { Link } from "react-router-dom";
import { ThemeToggle } from "./theme-toggle";
import { Scroll } from "lucide-react";
import logo from "@/logo.png";

export function LandingPage() {
  return (
    <div className="min-h-screen flex items-start justify-center p-4">
      <div className="w-full max-w-2xl mx-auto">
        <div className="flex justify-end mb-4">
          <ThemeToggle />
        </div>
        <div className="flex flex-col items-center justify-center mb-12 gap-4 text-center">
          <img src={logo} alt="Ultimate Warlock" className="h-48 w-auto" />
        </div>

        <Link
          to="/creator"
          className="bg-primary hover:bg-primary/90 transition-colors rounded-lg flex flex-col items-center justify-center p-8 gap-3 text-primary-foreground font-semibold text-xl text-center min-h-[140px] mb-8 w-full"
        >
          <Scroll className="h-8 w-8" />
          Character Creator
        </Link>

        <h2 className="text-lg font-semibold mb-3 text-muted-foreground">
          Character Creation Reference
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
          <Link
            to="/coreskills"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Core Skills
          </Link>
          <Link
            to="/patrons"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Patrons
          </Link>
          <Link
            to="/otherworldlygifts"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Otherworldly Gifts
          </Link>
        </div>

        <h2 className="text-lg font-semibold mb-3 text-muted-foreground">
          Game Rules
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
          <Link
            to="/basicterms"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Basic Terms
          </Link>
          <Link
            to="/wealthlevel"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Wealth &amp; Currency
          </Link>
          <Link
            to="/lifeanddeath"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Life &amp; Death
          </Link>
          <Link
            to="/combat"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Combat
          </Link>
          <Link
            to="/spellcasting"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Spellcasting
          </Link>
          <Link
            to="/bandsandsigns"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Bands &amp; Signs
          </Link>
        </div>

        <h2 className="text-lg font-semibold mb-3 text-muted-foreground">
          The World
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-8">
          <Link
            to="/challengeof13"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Challenge of 13
          </Link>
          <Link
            to="/festivegames"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Festival Games
          </Link>
          <Link
            to="/cabals"
            className="bg-card hover:bg-accent transition-colors rounded-lg flex flex-col items-center justify-center p-4 gap-2 text-sm font-medium text-center min-h-[80px] border border-border"
          >
            Cabals
          </Link>
        </div>
      </div>
    </div>
  );
}
